import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import SidebarApplicants from "../../../Components/SidebarApplicants";

const SubmissionComplete = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid container xs={12} className="Liq-Container HRPortal">
      <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
        <SidebarApplicants />
      </Grid>
      <Grid xs={12} md={10} container justify="center" className="PageContent">
        <Grid className="PagesFrame">
          <PageHeader />
          <Grid id="PageTitle">Profile Submission</Grid>
          <div className="submission_inner">
            <div className="SubmissionTable"><div></div></div>
            <div className="main_cont">
              <>Profile Submission Process has been completed, in case of any query contact HR.</>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SubmissionComplete;
